import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Button, Grid } from '@material-ui/core';
import { DialogComponent } from 'common/components/index';
import { useDispatch } from 'react-redux';
import TimeClockJobPositionList from '../TimeclockJobPositionList/TimeclockJobPositionList';
import PersonSimpleView from 'common/components/PersonSimpleView/PersonSimpleView';
import { ActionResult } from 'common/constants';
import { IClockedInEmployee } from 'modules/timeclock/interfaces/timeclock';
import { ITimeClockEmployeeJobPosition } from 'common/interfaces/employee';
import {
  clockInEmployeePositionAction,
  getEmployeeTimeclockJobPositions,
} from 'modules/timeclock/state/actions';
import {
  selectClockedInActionResult,
  selectTimeclockJobPositions,
} from 'modules/timeclock/state/selectors';
import useRootSelector from 'common/hooks/useRootSelector';
import commonMessages from 'common/messages/messages';
import timeclockMessages from 'modules/timeclock/messages';

interface IProps {
  isOpen: boolean;
  isLoading?: boolean;
  onClose: () => void;
  clockedInEmployee: IClockedInEmployee;
}

const ClockInWithEmployeeAndPositionsModal = ({
  isOpen,
  isLoading = false,
  onClose,
  clockedInEmployee,
}: IProps): JSX.Element => {
  const dispatch = useDispatch();

  const jobPositions: ITimeClockEmployeeJobPosition[] = useRootSelector(
    selectTimeclockJobPositions,
  );
  const clockedInResult: ActionResult = useRootSelector(selectClockedInActionResult);

  useEffect(() => {
    if (clockedInEmployee.id) {
      dispatch(getEmployeeTimeclockJobPositions(clockedInEmployee.id));
    }
  }, [dispatch, clockedInEmployee]);

  useEffect(() => {
    if (clockedInResult === ActionResult.SUCCESS_ACTION) {
      dispatch(clockInEmployeePositionAction(null));

      if (clockedInEmployee.id) {
        dispatch(getEmployeeTimeclockJobPositions(clockedInEmployee.id));
      }
    }
  }, [dispatch, clockedInEmployee, clockedInResult]);

  return (
    <DialogComponent
      isOpen={isOpen}
      loading={isLoading}
      onClose={onClose}
      title={<FormattedMessage {...timeclockMessages.clockInEmployeeBtn} />}
      hasCustomFooter
      size="xs"
      supressBottomShadow
      hasShadowsOnScroll={false}
    >
      <Box marginBottom={2}>
        <PersonSimpleView
          bold
          firstName={clockedInEmployee.firstName}
          lastName={clockedInEmployee.lastName}
          imageUrl={clockedInEmployee.imageUrl}
        />
      </Box>

      {clockedInEmployee.id ? (
        <TimeClockJobPositionList jobPositions={jobPositions} employeeId={clockedInEmployee.id} />
      ) : null}

      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Button color="primary" fullWidth variant="text" onClick={onClose}>
            <FormattedMessage {...commonMessages.cancelBtn} />
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button variant="contained" fullWidth color="primary" onClick={onClose}>
            <FormattedMessage {...commonMessages.confirmBtn} />
          </Button>
        </Grid>
      </Grid>
    </DialogComponent>
  );
};

export default ClockInWithEmployeeAndPositionsModal;
